/**
 * Thrown when render finds a missing entity but no Apollo error to rethrow
 * (resolver returned `null` cleanly). `ContentErrorBoundary` classifies it
 * as an expected denial — renders the not-available state, skips Datadog.
 */
export class EntityNotFoundError extends Error {
  readonly entityKind: string
  readonly entityId: string

  constructor(entityKind: string, entityId: string) {
    super(`${entityKind} ${entityId} not found`)
    this.name = 'EntityNotFoundError'
    this.entityKind = entityKind
    this.entityId = entityId
  }
}
